export const TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
};

export const TICKET_PRIORITY = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
};

export const TICKET_CATEGORY = {
  BILLING: 'billing',
  TECHNICAL: 'technical',
  ACCOUNT: 'account',
  APPOINTMENTS: 'appointments',
  FEATURE_REQUEST: 'feature_request',
  OTHER: 'other',
};

export const TICKET_SORT = {
  CREATED_DESC: 'created_desc',
  UPDATED_DESC: 'updated_desc',
};

